export default {
  badge: 'Σήμα',
  open: 'Άνοιγμα',
  close: 'Κλείσιμο',
  dismiss: 'Απόρριψη',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Ακύρωση',
  },
  dataIterator: {
    noResultsText: 'Δε βρέθηκαν αποτελέσματα',
    loadingText: 'Φόρτωση αντικειμένου...',
  },
  dataTable: {
    itemsPerPageText: 'Γραμμές ανά σελίδα:',
    ariaLabel: {
      sortDescending: 'Ταξινομημένο φθίνουσα.',
      sortAscending: 'Ταξινομημένο αύξουσα.',
      sortNone: 'Χωρίς ταξινόμηση.',
      activateNone: 'Ενεργοποιήστε για να καταργήσετε την ταξινόμηση.',
      activateDescending: 'Ενεργοποιήστε για φθίνουσα ταξινόμηση.',
      activateAscending: 'Ενεργοποιήστε για αύξουσα ταξινόμηση.',
    },
    sortBy: 'Ταξινόμηση κατά',
  },
  dataFooter: {
    itemsPerPageText: 'Αντικείμενα ανά σελίδα:',
    itemsPerPageAll: 'Όλα',
    nextPage: 'Επόμενη σελίδα',
    prevPage: 'Προηγούμενη σελίδα',
    firstPage: 'Πρώτη σελίδα',
    lastPage: 'Τελευταία σελίδα',
    pageText: '{0}-{1} από {2}',
  },
  dateRangeInput: {
    divider: 'έως',
  },
  datePicker: {
    itemsSelected: '{0} επιλεγμένα',
    range: {
      title: 'Επιλέξτε ημερομηνίες',
      header: 'Εισαγάγετε ημερομηνίες',
    },
    title: 'Επιλέξτε ημερομηνία',
    header: 'Εισαγάγετε ημερομηνία',
    input: {
      placeholder: 'Εισαγάγετε ημερομηνία',
    },
    ariaLabel: {
      previousMonth: 'Προηγούμενος μήνας',
      nextMonth: 'Επόμενος μήνας',
      selectYear: 'Επιλέξτε έτος',
      previousYear: 'Προηγούμενο έτος',
      nextYear: 'Επόμενο έτος',
      selectMonth: 'Επιλέξτε μήνα',
      selectDate: '{0}',
      currentDate: 'Σήμερα, {0}',
    },
  },
  noDataText: 'Χωρίς δεδομένα',
  carousel: {
    prev: 'הקודם חזותי',
    next: 'הבא חזותי',
    ariaLabel: {
      delimiter: 'Διαφάνεια καρουζέλ {0} από {1}',
    },
  },
  calendar: {
    moreEvents: '{0} ακόμη',
    today: 'Σήμερα',
  },
  input: {
    clear: 'Καθαρισμός {0}',
    prependAction: '{0} προσαρτημένη ενέργεια',
    appendAction: '{0} επισυναπτόμενη ενέργεια',
    otp: 'Παρακαλώ εισαγάγετε χαρακτήρα OTP {0}',
  },
  fileInput: {
    counter: '{0} αρχεία',
    counterSize: '{0} αρχεία ({1} συνολικά)',
  },
  fileUpload: {
    title: 'Σύρετε και αποθέστε αρχεία εδώ',
    divider: 'ή',
    browse: 'Αναζήτηση αρχείων',
  },
  timePicker: {
    am: 'ΠΜ',
    pm: 'ΜΜ',
    title: 'Επιλέξτε ώρα',
    hour: 'Ώρα',
    minute: 'Λεπτά',
    second: 'Δευτερόλεπτα',
    notAllowed: 'Η τιμή δεν επιτρέπεται',
  },
  pagination: {
    ariaLabel: {
      root: 'Πλοήγηση με προορισμούς',
      next: 'Επόμενη σελίδα',
      previous: 'Προηγούμενη σελίδα',
      page: 'Πήγαινε στην σελίδα {0}',
      currentPage: 'Τρέχουσα σελίδα, σελίδα {0}',
      first: 'Πρώτη σελίδα',
      last: 'Τελευταία σελίδα',
    },
  },
  stepper: {
    next: 'Επόμενο',
    prev: 'Προηγούμενο',
  },
  rating: {
    ariaLabel: {
      item: 'Βαθμολογία {0} από {1}',
    },
  },
  loading: 'Φόρτωση...',
  infiniteScroll: {
    loadMore: 'Φόρτωση περισσότερων',
    empty: 'Δεν υπάρχουν άλλα',
  },
  rules: {
    required: 'Αυτό το πεδίο είναι υποχρεωτικό',
    email: 'Παρακαλώ εισάγετε μια έγκυρη διεύθυνση email',
    number: 'Αυτό το πεδίο μπορεί να περιέχει μόνο αριθμούς',
    integer: 'Αυτό το πεδίο μπορεί να περιέχει μόνο ακέραιους αριθμούς',
    capital: 'Αυτό το πεδίο μπορεί να περιέχει μόνο κεφαλαία γράμματα',
    maxLength: 'Πρέπει να εισάγετε το πολύ {0} χαρακτήρες',
    minLength: 'Πρέπει να εισάγετε τουλάχιστον {0} χαρακτήρες',
    strictLength: 'Το μήκος του πεδίου που εισήχθη δεν είναι έγκυρο',
    exclude: 'Ο χαρακτήρας {0} δεν επιτρέπεται',
    notEmpty: 'Παρακαλώ επιλέξτε τουλάχιστον μία τιμή',
    pattern: 'Μη έγκυρη μορφή',
  },
  command: {
    search: 'Πληκτρολογήστε μια εντολή ή αναζητήστε...',
  },
  hotkey: {
    then: 'στη συνέχεια',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'Πάνω βέλος',
    downArrow: 'Κάτω βέλος',
    leftArrow: 'Αριστερό βέλος',
    rightArrow: 'Δεξί βέλος',
    backspace: 'Backspace',
    space: 'Διάστημα',
    plus: 'συν',
    shortcut: 'Συντόμευση πληκτρολογίου: {0}',
    or: 'ή',
  },
  video: {
    play: 'Αναπαραγωγή',
    pause: 'Παύση',
    seek: 'Αναζήτηση',
    volume: 'Ένταση',
    showVolume: 'Εμφάνιση ελέγχου έντασης',
    mute: 'Σίγαση',
    unmute: 'Κατάργηση σίγασης',
    enterFullscreen: 'Πλήρης οθόνη',
    exitFullscreen: 'Έξοδος από πλήρη οθόνη',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'Επιλογή χρώματος από την οθόνη',
      hueSlider: 'Απόχρωση',
      alphaSlider: 'Άλφα',
      redInput: 'Κόκκινο',
      greenInput: 'Πράσινο',
      blueInput: 'Μπλε',
      alphaInput: 'Άλφα',
      hueInput: 'Απόχρωση',
      saturationInput: 'Κορεσμός',
      lightnessInput: 'Φωτεινότητα',
      hexInput: 'Δεκαεξαδική τιμή',
      hexaInput: 'Δεκαεξαδική τιμή με άλφα',
      changeFormat: 'Αλλαγή μορφής χρώματος',
    },
  },
}
